module.exports = __webpack_public_path__ + "img/FR18450.611769c3.png";